<template>
  <div class="row-height">
    <div class="no-padding col-xl-12 col-lg-12 col-md-12">
      <b-card class="row-height">
        <b-row style="padding: 0 15px">
          <div class="col-xl-6 col-lg-6 col-sm-12">
            <h2 class="font-weight-bolder" style="color: #1B4332 ;">
              {{ $t("invoices") }}
            </h2>
          </div>
          <div class="col-xl-6 col-lg-6 col-sm-12" align="right">
            <b-button variant="primary" @click="openAddInvoice">
              {{$t("add_new_invoice(s)") }}
            </b-button>
          </div>
        </b-row>

        <div v-if="!showPdfViewer">
          <b-col class="mb-5 col-md-12">
            <Table
                :showFilter="true"
                hover
                :fields="fields"
                :isSeller="true"
                @row-clicked="myRowClickHandler"
                :url="'/invoice/list'"
            >
              <template #cell(id)="data">
                <b-link @click="goToDetails(data.item)" style="width:55px;" class="badge badge-light-primary">
                  I-{{ data.item.id }}
                </b-link>
              </template>

              <template #cell(debtor)="data">
                <span v-if="data.item.invoice_debtor != null">{{ data.item.invoice_debtor.name }}</span>
                <span v-else>-</span>
              </template>

              <template #cell(due_date)="data">
                <span v-if="data.item.due_date" :class="{'text-danger': isOverdue(data.item)}" style="position:relative;">
                  {{ data.item.due_date }}
                  <span v-if="isOverdue(data.item)" style="position: absolute; top: -4px; right: -20px">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                      <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z"/>
                      <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/>
                    </svg>
                  </span>
                </span>
                <span v-else>-</span>
              </template>

              <template #cell(amount)="data">
                <span v-if="data.item.amount != null">{{ amountFormat(data.item.amount, data.item.currency.name) }}</span>
                <span v-else>-</span>
              </template>

              <template #cell(invoice_number)="data">
                <span v-html=" data.item && data.item.invoice_number ? data.item.invoice_number : '-' "></span>
              </template>

              <template #cell(status)="data">
                <span :class="getStatus(data).class">
                  {{ $t(getStatus(data).label) }}
                </span>
              </template>
              <template #cell(custom)="data">
                <b-button
                    v-if="data.item.status === 0  ||  data.item.status === 5 || ( data.item.status === 16 && !data.item.purchase_confirmed)"
                    class="mt-1 web"
                    @click="goToDetails(data.item)"
                    variant="primary"
                    size="sm"
                >
                  {{ $t(data.item.status === 16 ? 'confirm' :'sell') }}
                </b-button>
                <b-button
                    v-b-tooltip.hover :title="$t('read_pdf')"
                    class="mt-1 ml-1 web"
                    @click="downloadPdf(data.item.id, data.item)"
                    variant="outline-success"
                    size="sm"
                >
                  <FeatherIcon icon="BookOpenIcon"/>
                </b-button>
                <br/>
              </template>
            </Table>
          </b-col>
        </div>

        <div class="row" v-if="false">
          <div class="col-md-4">
            <Table
                :showFilter="false"
                hover
                :fields="fields1"
                @row-clicked="myRowClickHandler"
                :url="'/invoice/list'"
            >
              <template #cell(id)="data">
                {{ data.item.title }}
              </template>

              <template #cell(custom)="data">
                <b-button
                    class="mt-1 mr-1"
                    @click="downloadPdf(data.item.id, data.item)"
                    variant="outline-success"
                    size="sm"
                >
                  <FeatherIcon icon="DownloadIcon"></FeatherIcon>
                </b-button>
                <b-button
                    class="mt-1"
                    @click="readPdf(data.item.id, data.item)"
                    variant="outline-success"
                    size="sm"
                >
                  <FeatherIcon icon="BookOpenIcon"></FeatherIcon>
                </b-button>
                <br/>
              </template>
            </Table>
          </div>
          <div class="col-md-8">
            <embed
                class="mt-1"
                id="embed-pdf"
                :src="
                'data:application/' +
                type +
                ';headers=test' +
                item.title +
                ';base64,' +
                base64 +
                '#toolbar=0'
              "
                type="application/pdf"
                width="100%"
            />
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import Table from "@/components/common/Table.vue";
import fileDownload from "js-file-download";
import PdfViewer from "../../views/PdfViewer.vue";
import {CurrencyAmountFormat} from "@core/utils/CurrencyAmountFormat";

export default {
  components: {Table, PdfViewer},
  data() {
    return {
      status: "",
      showPdfViewer: false,
      type: "",
      base64: "",
      source: null,
      invoices: [],
      companies: [],
      isLoading: false,
      item: null,
      seller: {
        default_inactive_days: 7
      },
      fields: [
        {
          text: "ID",
          label: "ID",
          align: "start",
          key: "id",
          sortable: true,
        },
        {label: "debtor", align: "start", key: "debtor", sortable: false},
        {
          label: "original_invoice_number",
          align: "start",
          key: "invoice_number",
          sortable: false,
        },
        {
          label: "due_date",
          align: "start",
          key: "due_date",
          sortable: false,
        },
        {
          label: "original invoice amount",
          align: "start",
          key: "amount",
          sortable: false,
        },
        {label: "status", key: "status", customSlot: true, sortable: false},
        {label: "", customSlot: true, key: "custom", class: "text-right"},
      ],
      fields1: [
        {
          text: "reference",
          label: "reference",
          align: "start",
          key: "id",
          sortable: true,
        },
        {label: "Title", customSlot: true, key: "custom", class: ""},
      ],
      global_settings: null
    };
  },
  watch: {
    sideBar() {
      this.showPdfViewer = false;
    },
  },
  computed: {
    sideBar() {
      return this.$store.state.app.sidebar;
    },
  },
  methods: {
    getStatus({ value, item }) {
      const globalSettings = this.global_settings;

      const map = {
        0: { class: "text-success", label: "Open" },
        1: { class: "text-success", label: "active_marketplace_offer" },
        2: { class: "text-danger", label: "rejected" },
        3: { class: "text-secondary", label: "scoring_required" },
        4: { class: "text-secondary", label: "scored" },
        5: { class: "text-secondary", label: "click_sell_invoice" },
        6: item?.is_reverse === 1 ? { class: "text-secondary", label: "supplier_confirmation_required" } : { class: "text-secondary", label: "debtor_confirmation_required" },
        7: globalSettings?.status ? { class: "text-danger", label: "rejected" } : { class: "text-secondary", label: "get_offer_status" },
        8: { class: "text-secondary", label: "soon_goes_active" },
        9: { class: "text-secondary", label: "in_sale" },
        10: { class: "text-secondary", label: "sold" },
        11: { class: "text-secondary", label: "settled" },
        12: { class: "text-secondary", label: "get_offer_status" },
        13: { class: "text-danger", label: "invoice_default" },
        14: { class: "text-danger", label: "deactivated" },
        15: { class: "text-warning", label: "removed_from_marketplace" },
        16: { class: "text-secondary", label: item?.purchase_confirmed ? "waiting_admin_approval" : "required_seller_confirmation" },
      };

      return map[value] || '';
    },
    amountFormat(amount, currency) {
      return CurrencyAmountFormat(amount, currency)
    },

    myRowClickHandler(record) {
      this.$router.push("/invoice/" + record.id);
    },

    readPdf(id, item) {
      this.$store.commit("app/ON_SIDEBAR_CLICK", false);
      this.item = item;
      this.$http
          .post("/invoice/read/" + id, {
            responseType: "json",
          })
          .then((response) => {
            this.type = "";
            this.base64 = "";

            this.base64 = response.data.value.b64;
            this.type = response.data.value.ext;
            this.$store.commit("app/SET_FILE_TYPE", this.type);
            this.$store.commit("app/SET_FILE_BASE64", this.base64);

            window.open("/read-files", "_blank");
          })
          .catch(() => {
            this.isLoading = false;
          });
    },

    downloadPdf(id, item) {
      this.isLoading = true;
      this.$store.commit("app/ON_SIDEBAR_CLICK", false);
      this.item = item;
      this.$http
          .post(
              "/invoice/download/" + id,
              {},
              {
                responseType: "blob",
              }
          )
          .then((response) => {
            let filename = 'invoice.pdf';
            const disposition = response.headers['content-disposition'];
            if (disposition && disposition.includes('filename=')) {
              filename = disposition
                  .split('filename=')[1]
                  .split(';')[0]
                  .replace(/['"]/g, '');
            }

            fileDownload(response.data, filename);
          })
          .catch(() => {
            this.isLoading = false;
          });
    },

    goToDetails(item) {
      if (item) {
        this.$router.push("/invoice/" + item.id);
      }
    },
    openAddInvoice() {
      if (this.$store.getters["app/checkRequiredSigningGate"]) return
      this.$router.push('/invoices/add-new')
    },
    isOverdue(invoice) {
      if (!invoice.due_date) return false;
      const today = new Date();
      const due = new Date(invoice.due_date);
      return invoice.status === 10 && today >= due;
    }
  },

};
</script>
<style>
</style>
